$(document).ready(function() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams.get('sizes') !== null) {
        const sizes = urlParams.get('sizes').split(';');
        $('.collection.collection--search .product_card').each(function() {
            let found = false;
            for (let i = 0; i < sizes.length; i++) {
                if ($(this).find('.product_card_sizes > span:not(.not_active)[data-size="' + sizes[i] + '"]').length === 1) {
                    found = true;
                    break;
                }
            }

            if (!found) $(this).hide();
        });

        $('.collection.collection--search').show();
        if ($('.collection.collection--search .product_card:visible').length === 0) {
            $('.collection.collection--search').replaceWith("<div class='page'><div class='page_text'><p>No products found.</p></div></div>");
        }
    } else {
        $('.collection.collection--search').show();
    }
});
